export default __webpack_public_path__ + "static/media/InsideMuscles_09.872cc711.png";